'use strict';

module.exports = function (ngModule) {
    ngModule.directive('copyright', require('./copyright'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/copyright/index.js
 **/